import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, List, ListItem, ListItemText, IconButton, Container,  } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

function GiftDetails({ data }) {
    const { images, ...otherInfo } = data;
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            if (images && images.length > 0) {
                nextSlide();
            }
      }, 5000);
      return () => clearInterval(interval);
  }, [images]);

    if (!data) {
        return <Typography>No data to display</Typography>;
    }


     const nextSlide = () => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
      };

      const prevSlide = () => {
        setCurrentImageIndex((prevIndex) =>
          prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
      };

      

    return (
        <Container>
            <Typography variant="h6" gutterBottom>
                {otherInfo.name} 
            </Typography>
            <Grid container spacing={2} sx={{ padding: 2 }}>
                {/* Carousel Section */}
                {images && images.length > 0 && (
                    <Grid item xs={12} md={12} sx={{ position: 'relative'}}>
                        <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                        <IconButton onClick={prevSlide} sx={{position: 'absolute', left: 10, zIndex: 10}} >
                            <ArrowBackIosIcon/>
                            </IconButton>
                            <img
                                src={images[currentImageIndex]}
                                alt={`Slide ${currentImageIndex + 1}`}
                                style={{ maxHeight: '300px', objectFit: 'contain', width: '100%',}}
                            />
                            <IconButton onClick={nextSlide} sx={{position: 'absolute', right: 10, zIndex: 10}} >
                                <ArrowForwardIosIcon/>
                            </IconButton>
                        </Box>
                    </Grid>
                )}
                {/* Key Value List */}
                <Grid item xs={12} md={12}>
                    <Box sx={{ backgroundColor: 'white', padding: 2, borderRadius: 1 }}>
                    <List>
                        <ListItemText primary="Description" secondary={otherInfo.description} />
                        <ListItemText primary="Points" secondary={otherInfo.nbr_pts} />
                        <ListItemText primary="Quantity" secondary={otherInfo.quantity} />
                        {otherInfo.isActive ? (
                            <Box sx={{ color: 'green', fontWeight: 'bold' }}>
                                Active
                            </Box>
                        ) : (
                            <Box sx={{ color: 'red', fontWeight: 'bold' }}>
                                Inactive
                            </Box>
                        )}
                    </List>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
}

export default GiftDetails;